import { __assign } from "tslib";
import { composeHeaders } from './headers';
import { HTTP_MOCK_SERVER_URL } from './constants';
import { changeHost } from './utils';
export var buildOptions = function (requestOptions, wixHeadersOpts, shouldRewriteToMockServer) {
    if (shouldRewriteToMockServer === void 0) { shouldRewriteToMockServer = false; }
    var url = requestOptions.url, disableWixHeaders = requestOptions.disableWixHeaders, orgHeaders = requestOptions.headers;
    var composedHeaders = composeHeaders({
        url: url,
        disableWixHeaders: disableWixHeaders,
        wixHeadersOpts: wixHeadersOpts,
    });
    var localConfigOptions = maybeRedirectToMockServer(url, shouldRewriteToMockServer);
    var newOptions = __assign(__assign(__assign({}, requestOptions), localConfigOptions), { headers: __assign(__assign({}, composedHeaders), orgHeaders) });
    return newOptions;
};
function maybeRedirectToMockServer(url, shouldRewriteToMockServer) {
    if (shouldRewriteToMockServer) {
        var mockUrl = new URL(HTTP_MOCK_SERVER_URL);
        return {
            url: changeHost(url, mockUrl.host),
        };
    }
    return {};
}
//# sourceMappingURL=options.js.map